// extracted by mini-css-extract-plugin
module.exports = {"SearchButton":"SearchButton_SearchButton__3vO3l","search":"SearchButton_search__2P9cN"};